import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonGroup,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Badge
} from 'reactstrap';
import $ from 'jquery';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import StudentPage from '../../views/StudentPage';
const GLOBAL = require('../../Globals');

class CustomReport extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			id: '',
			accyear: [],
			acyear: '',
			_message: '',
			alertClass: '',
			posts: [],
			clas: [],
			sect: [],
			reli: [],
			desti: [],
			communi: [],
			vehic: [],
			viewcls: 0,
			viewsec: 0,
			viewcom: 0,
			_redirect: false,
			collapse: false,
			postFilter: [],
			collapse: false,
			allsection: []
		}
		this.onChange = this.onChange.bind(this);
		this.toggleCollapse = this.toggleCollapse.bind(this);
		this.printDocument = this.printDocument.bind(this);
		this.printSecDocument = this.printSecDocument.bind(this);
		this.printClassDocument = this.printClassDocument.bind(this);
		this.printGenDocument = this.printGenDocument.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onSecChange = this.onSecChange.bind(this);
		this.onComChange = this.onComChange.bind(this);
		this.onGenChange = this.onGenChange.bind(this);
		this.onViewClick = this.onViewClick.bind(this);
	}

	onClassChange(e) {

		if (e.target.checked) {

			this.setState({ viewcls: 1 });
		}
		else {

			this.setState({ viewcls: 0 });
		}
	}

	onSecChange(e) {

		if (e.target.checked) {

			this.setState({ viewsec: 1 });
		}
		else {

			this.setState({ viewsec: 0 });
		}
	}

	onComChange(e) {

		if (e.target.checked) {

			this.setState({ viewcom: 1 });
		}
		else {

			this.setState({ viewcom: 0 });
		}
	}

	onGenChange(e) {

		if (e.target.checked) {

			this.setState({ viewgen: 1 });
		}
		else {

			this.setState({ viewgen: 0 });
		}
	}

	toggleCollapse() {

		this.setState({ viewtab: 0 });
		this.setState({ collapse: !this.state.collapse });
	}

	printDocument() {

		var content = document.getElementById("comreport");
		var pri = document.getElementById("print_frame").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	printSecDocument() {

		var content = document.getElementById("secreport");
		var pri = document.getElementById("print_frame1").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	printClassDocument() {

		var content = document.getElementById("clsreport");
		var pri = document.getElementById("print_frame2").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	printGenDocument() {

		var content = document.getElementById("genreport");
		var pri = document.getElementById("print_frame3").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	onViewClick(e) {

		this.setState({ collapse: false });
		this.setState({ viewtab: 1 });
	}

	onChange(e) {

		this.setState({ [e.target.name]: e.target.value });
		console.log(this.state);
		this.getdata();
	}

	/** this function will be call when page loading **/
	componentWillMount() {

		this.getacyear();
		this.getclass();
		this.getsection();
		this.getcommunity();
	}

	/** get Academic Year **/
	getacyear() {
		$("#showLoader").show();
		GetData('academic/getacyear').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getclass();
				this.getdata();
				this.getallsection();
			}
		});
	}

	/** get Class **/
	getallsection() {

		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('section/getsecbyacyear/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					allsection: responseJson
				});
			}
		});
	}

	getdata() {
		this.setState({ posts: [] });
		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('student/getstdreportbyac/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson,
					postFilter: responseJson
				});
				$('#show option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}

	/** get Class **/
	getclass() {
		$("#showLoader").show();
		GetData('classs/getclass').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					clas: responseJson
				});
			}
		});
	}

	/** get Section **/
	getsection() {
		$("#showLoader").show();
		GetData('section/getsection').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					sect: responseJson
				});
			}
		});
	}

	/** get Community **/
	getcommunity() {
		$("#showLoader").show();
		GetData('caste/getcommunity').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					communi: responseJson
				});
			}
		});
	}

	getcountbysec(cls, sec) {

		var count = 0;

		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.posts[i].class == cls && this.state.posts[i].section == sec) {

				count += 1;
			}
		}

		return count;
	}

	getonlyyear(jdate) {

		var emptydob = '';
		if (jdate != '0000-00-00') {
			var ed = new Date(jdate);
			var edate = ed.setDate(ed.getDate());

			var d = new Date(edate),
				month = '' + (d.getMonth() + 1),
				day = '' + (d.getDate()),
				year = d.getFullYear();

			if (month.length < 2) month = '0' + month;
			if (day.length < 2) day = '0' + day;

			return parseInt(year);
		}
		else {

			var year = 2017;
			return parseInt(year);
		}
	}

	getcountbycls(cls) {

		var count = 0;

		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.posts[i].class == cls) {

				count += 1;
			}
		}

		return count;
	}

	getoldcountbycls(cls) {

		var count = 0;
		var curyear = 2018//this.state.accyear[0].startyear;

		for (var i = 0; i < this.state.posts.length; i++) {
			// console.log('old '+this.getonlyyear(this.state.posts[i].admissiondate)+' '+curyear);
			var checkyear = this.state.posts[i].admissiondate;
			if (this.state.posts[i].class == cls && this.getonlyyear(checkyear) < parseInt(curyear)) {

				count += 1;
			}
		}

		return count;
	}

	getnewcountbycls(cls) {

		var count = 0;
		var curyear = 2018//this.state.accyear[0].startyear;

		for (var i = 0; i < this.state.posts.length; i++) {
			// console.log('new '+this.getonlyyear(this.state.posts[i].admissiondate)+' '+curyear);
			var checkyear = this.state.posts[i].admissiondate;
			if (this.state.posts[i].class == cls && this.getonlyyear(checkyear) >= parseInt(curyear)) {

				count += 1;
			}
		}

		return count;
	}

	getoldcountbyclsandsec(cls, sec) {

		var count = 0;
		var curyear = 2018//this.state.accyear[0].startyear;

		for (var i = 0; i < this.state.posts.length; i++) {
			// console.log('old '+this.getonlyyear(this.state.posts[i].admissiondate)+' '+curyear);
			var checkyear = this.state.posts[i].admissiondate;
			if (this.state.posts[i].class == cls && this.state.posts[i].section == sec && this.getonlyyear(checkyear) < parseInt(curyear)) {

				count += 1;
			}
		}

		return count;
	}


	getnewcountbyclsandsec(cls, sec) {

		var count = 0;
		var curyear = 2018//this.state.accyear[0].startyear;

		for (var i = 0; i < this.state.posts.length; i++) {
			// console.log('new '+this.getonlyyear(this.state.posts[i].admissiondate)+' '+curyear);
			var checkyear = this.state.posts[i].admissiondate;
			if (this.state.posts[i].class == cls && this.state.posts[i].section == sec && this.getonlyyear(checkyear) >= parseInt(curyear)) {

				count += 1;
			}
		}

		return count;
	}

	getcountbycomm(cls, sec, com) {

		var count = 0;

		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.posts[i].class == cls && this.state.posts[i].section == sec && this.state.posts[i].community == com) {

				count += 1;
			}
		}

		return count;
	}

	getmalecount(cls, sec) {

		var count = 0;

		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.posts[i].class == cls && this.state.posts[i].section == sec && this.state.posts[i].gender == 'Male') {

				count += 1;
			}
		}

		return count;
	}

	getfemalecount(cls, sec) {

		var count = 0;

		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.posts[i].class == cls && this.state.posts[i].section == sec && this.state.posts[i].gender == 'Female') {

				count += 1;
			}
		}

		return count;
	}

	gettotalmalecount() {

		var count = 0;

		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.posts[i].gender == 'Male') {

				count += 1;
			}
		}

		return count;
	}

	gettotalfemalecount() {

		var count = 0;

		for (var i = 0; i < this.state.posts.length; i++) {

			if (this.state.posts[i].gender == 'Female') {

				count += 1;
			}
		}

		return count;
	}

	render() {

		var acyear = this.state.accyear;
		// var items = this.state.clas;
		var cas = this.state.caste;
		// var com = this.state.communi;
		var rc = this.state.rcod;

		if (this.state._redirect) {

			return (<Redirect to={'/leave/editcategory/' + this.state.idd} />);

		}

		/** map Class value to react multi select **/
		var clss = this.state.clas.map(function (e, key) {
			return (
				{ value: e.id, label: e.class }
			);
		});

		/** map Section value to react multi select **/
		var sec = this.state.sect.map(function (e, key) {
			return (
				{ value: e.id, label: e.section }
			);
		});

		/** map Community value to react multi select **/
		var com = this.state.communi.map(function (e, key) {
			return (
				{ value: e.id, label: e.community }
			);
		});

		/** map Religion value to react multi select **/
		var rel = this.state.reli.map(function (e, key) {
			return (
				{ value: e.id, label: e.religion }
			);
		});

		/** map Destination value to react multi select **/
		var trans = this.state.desti.map(function (e, key) {
			return (
				{ value: e.id, label: e.pickanddrop }
			);
		});

		/** map Vehicle value to react multi select **/
		var vehi = this.state.vehic.map(function (e, key) {
			return (
				{ value: e.id, label: e.regno }
			);
		});

		/** set type select box **/
		this.sttype = [
			{ value: '', name: 'Select' },
			{ value: 'rte', name: 'RTE' },
			{ value: 'normal', name: 'Normal' }
		];

		/** set gender select box **/
		this.gend = [
			{ value: 'Male', name: 'Male' },
			{ value: 'Female', name: 'Female' }
		];

		/** map gender value to react multi select **/
		var gen = this.gend.map(function (e, key) {
			return (
				{ value: e.value, label: e.name }
			);
		});

		/** map Type value to react multi select **/
		var stype = this.sttype.map(function (e, key) {
			return (
				{ value: e.value, label: e.name }
			);
		});

		if (this.state.viewtab == 1) {

			if (this.state.viewcls == '1') {

				$("#clsreport").show();
			}

			if (this.state.viewsec == '1') {

				$("#secreport").show();
			}

			if (this.state.viewcom == '1') {

				$("#comreport").show();
			}

			if (this.state.viewgen == '1') {

				$("#genreport").show();
			}

		}
		else {

			$("#clsreport").hide();
			$("#secreport").hide();
			$("#comreport").hide();
			$("#genreport").hide();
		}

		return (
			<div>
				<StudentPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>Report</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onChange} required id="year">
										<option value="">Select Academic Year</option>
										{
											acyear.map(function (item) {
												return <option value={item.id}>{item.value}</option>;
											})
										}
									</select>
									<Button color="primary" className="btn-right" onClick={this.toggleCollapse}>Filter</Button>
								</CardHeader>
								<Collapse isOpen={this.state.collapse} >
									<CardBody>
										<Row>
											<Col md="2">
												<input type="checkbox" onChange={this.onClassChange} />&nbsp;&nbsp;Class
							  </Col>
											<Col md="2">
												<input type="checkbox" onChange={this.onSecChange} />&nbsp;&nbsp;Section
							  </Col>
											<Col md="2">
												<input type="checkbox" onChange={this.onComChange} />&nbsp;&nbsp;Community
							  </Col>
											<Col md="2">
												<input type="checkbox" onChange={this.onGenChange} />&nbsp;&nbsp;Gender
							  </Col>
											<Col md="12">
												<FormGroup>
													<Label htmlFor="name"></Label>
													<Button color="danger" className="btn-right" id="btn-repview" onClick={this.onViewClick}>View</Button>
												</FormGroup>
											</Col>
										</Row>
									</CardBody>
								</Collapse>
							</Card>
						</Col>
					</Row>
					<Row id="clsreport">
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>Class Wise Report - <Badge color="danger">{this.state.posts.length}</Badge></strong>
									<Button size="sm" className="btn-right" color="warning" onClick={this.printClassDocument}><i className="fa fa-print"></i> Print</Button>
									<ReactHTMLTableToExcel
										id="test-table-xls-button"
										className="download-table-xls-button btn-right"
										table="table-to-xls_class"
										filename="classreport"
										sheet="tablexls"
										Button size="xs"
										buttonText="Export" />
								</CardHeader>
								<CardBody>
									<Row>
										<Col md="12">
											<Table responsive style={{ border: '1px solid black', borderCollapse: 'collapse' }} width="100%" id="table-to-xls_class">
												<thead>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>Class Name</th>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>Old Student</th>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>New Student</th>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>Total Students</th>
												</thead>
												<tbody>
													{this.state.clas.map((item, index) =>

														<tr key={item}>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{item.class}</td>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{this.getoldcountbycls(item.id)}</td>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{this.getnewcountbycls(item.id)}</td>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{this.getcountbycls(item.id)}</td>
														</tr>
													)}
												</tbody>
											</Table>
										</Col>
									</Row>
								</CardBody>
								<iframe name="print_frame" id="print_frame2" width="0" height="0" frameborder="0" src="about:blank"></iframe>
							</Card>
						</Col>
					</Row>
					<Row id="secreport">
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>Section Wise Report - <Badge color="danger">{this.state.posts.length}</Badge></strong>
									<Button size="sm" className="btn-right" color="warning" onClick={this.printSecDocument}><i className="fa fa-print"></i> Print</Button>
									<ReactHTMLTableToExcel
										id="test-table-xls-button"
										className="download-table-xls-button btn-right"
										table="table-to-xls_section"
										filename="sectionreport"
										sheet="tablexls"
										Button size="xs"
										buttonText="Export" />
								</CardHeader>
								<CardBody>
									<Row>
										<Col md="12">
											<Table responsive style={{ border: '1px solid black', borderCollapse: 'collapse' }} width="100%" id="table-to-xls_section">
												<thead>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>Class Name</th>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>Section Name</th>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>Old Students</th>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>New Students</th>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>Total Students</th>
												</thead>
												<tbody>
													{this.state.allsection.map((item, index) =>

														<tr key={item}>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{item.cls}</td>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{item.secs}</td>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{this.getoldcountbyclsandsec(item.clas, item.section)}</td>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{this.getnewcountbyclsandsec(item.clas, item.section)}</td>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{this.getcountbysec(item.clas, item.section)}</td>
														</tr>
													)}
												</tbody>
											</Table>
										</Col>
									</Row>
								</CardBody>
								<iframe name="print_frame" id="print_frame1" width="0" height="0" frameborder="0" src="about:blank"></iframe>
							</Card>
						</Col>
					</Row>
					<Row id="comreport">
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>Community Wise Report - <Badge color="danger">{this.state.posts.length}</Badge></strong>
									<Button size="xs" className="btn-right" color="warning" onClick={this.printDocument}><i className="fa fa-print"></i> Print</Button>
									<ReactHTMLTableToExcel
										id="test-table-xls-button"
										className="download-table-xls-button btn-right"
										table="table-to-xls_com"
										filename="communityreport"
										sheet="tablexls"
										Button size="xs"
										buttonText="Export" />
								</CardHeader>
								<CardBody>
									<Row>
										<Col md="12">
											<Table responsive style={{ border: '1px solid black', borderCollapse: 'collapse' }} width="100%" id="table-to-xls_com">
												<thead>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>Class Name</th>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>Section Name</th>
													{this.state.communi.map((item, index) =>

														<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>{item.community}</th>
													)}
												</thead>
												<tbody>
													{this.state.allsection.map((item, index) =>

														<tr key={item}>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{item.cls}</td>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{item.secs}</td>
															{this.state.communi.map((item1, index1) =>

																<td width="80" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{this.getcountbycomm(item.clas, item.section, item1.id)}</td>
															)}

														</tr>
													)}
												</tbody>
											</Table>
										</Col>
									</Row>
								</CardBody>
								<iframe name="print_frame" id="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>
							</Card>
						</Col>
					</Row>
					<Row id="genreport">
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>Gender Wise Report - <Badge color="danger">{this.state.posts.length}</Badge>&nbsp;&nbsp;&nbsp;Male({this.gettotalmalecount()})&nbsp;&nbsp;&nbsp;Female({this.gettotalfemalecount()}) </strong>
									<Button size="sm" color="warning" className="btn-right" onClick={this.printGenDocument}><i className="fa fa-print"></i> Print</Button>
									<ReactHTMLTableToExcel
										id="test-table-xls-button"
										className="download-table-xls-button btn-right"
										table="table-to-xls_gen"
										filename="genderreport"
										sheet="tablexls"
										Button size="xs"
										buttonText="Export" />
								</CardHeader>
								<CardBody>
									<Row>
										<Col md="12">
											<Table responsive style={{ border: '1px solid black', borderCollapse: 'collapse' }} width="100%" id="table-to-xls_gen">
												<thead>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>Class Name</th>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>Section Name</th>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>Male</th>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>Female</th>
													<th style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px', textAlign: 'center' }}>Total</th>
												</thead>
												<tbody>
													{this.state.allsection.map((item, index) =>

														<tr key={item}>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{item.cls}</td>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{item.secs}</td>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{this.getmalecount(item.clas, item.section)}</td>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{this.getfemalecount(item.clas, item.section)}</td>
															<td width="100" align="center" style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '2px' }}>{this.getmalecount(item.clas, item.section) + this.getfemalecount(item.clas, item.section)}</td>
														</tr>
													)}
												</tbody>
											</Table>
										</Col>
									</Row>
								</CardBody>
								<iframe name="print_frame" id="print_frame3" width="0" height="0" frameborder="0" src="about:blank"></iframe>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default CustomReport;


// WEBPACK FOOTER //
// ./src/student/Report/CustomReport.js